var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnarchiveOutlined = function SvgUnarchiveOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m853.333 128 85.334 170.667v554.666A42.667 42.667 0 0 1 896 896H128a42.667 42.667 0 0 1-42.667-42.667V298.837L170.667 128zm0 256H170.667v426.667h682.666zM512 426.667l170.667 170.666h-128V768h-85.334V597.333h-128zm288.597-213.334H223.403l-42.624 85.334h662.485z"
  })));
};
export default SvgUnarchiveOutlined;